import { useQueryClient } from "@tanstack/react-query";
import { useContext, useState } from "react";
import useGetOrg from "src/hooks/useGetOrganization";
import { useDeleteUserRequest } from "src/services/organizations/commands/delete_user";
import SnackbarUtils from "src/utils/SnackbarUtils";

import Context from "../../Table/context";

const useDeleteUser = () => {
	const [isLoading, setIsLoading] = useState(false);
	const { state, actions } = useContext(Context);

	const { mutate } = useDeleteUserRequest();
	const queryClient = useQueryClient();

	const org = useGetOrg();

	const onSuccess = () => {
		setIsLoading(false);
		SnackbarUtils.success("El usuario ha sido eliminado con éxito.");
		actions.closeDialog();
		queryClient.refetchQueries({ queryKey: ["organization", "users"] });
	};

	const onError = () => {
		SnackbarUtils.error("Se ha producido un error al intentar borrar este usuario.");
		actions.closeDialog();
		setIsLoading(false);
	};

	const deleteUser = () => {
		setIsLoading(true);
		mutate({ orgId: org.id ?? "", userId: state.userId }, { onSuccess, onError });
	};

	return {
		deleteUser,
		isLoading
	};
};

export default useDeleteUser;
